import PropTypes from 'prop-types';
import React, { Component } from 'react';
import $ from 'jquery';

// HOC provides a base component with the current breakpoint. Defaults to the breakpoint prop name, but accepts
// a callback to map a breakpoint value to one or more props.
const withBreakpoint = (WrappedComponent, breakpointToProps = (breakpoint) => ({ breakpoint })) => {
    return class BreakpointsComponent extends Component {
        constructor(props) {
            super(props);

            this.state = {
                breakpoint: this.getBreakpointFromDom(),
            };

            this.updateBreakpoint = this.updateBreakpoint.bind(this);
        }

        getBreakpointFromDom() {
            return document.querySelector('html').getAttribute('data-media-query-breakpoint');
        }

        updateBreakpoint(_, breakpoint) {
            this.setState(() => ({ breakpoint }));
        }

        componentDidMount() {
            this.setState(() => ({ breakpoint: this.getBreakpointFromDom() }));
            $(document).on('media-query:match', this.updateBreakpoint);
        }

        componentWillUnmount() {
            $(document).unbind('media-query:match', this.updateBreakpoint);
        }

        render() {
            return (
                <WrappedComponent {...this.props} {...breakpointToProps(this.state.breakpoint)} />
            );
        }
    };
};

// Renders a component based on the current asimov breakpoint.  Falls back to other if no matching component is provided.
class BreakpointsBase extends Component {
    render() {
        if (this.props[this.props.breakpoint]) {
            return this.props[this.props.breakpoint];
        } else {
            return this.props.other;
        }
    }
}

BreakpointsBase.propTypes = {
    breakpoint: PropTypes.string.isRequired,
    small: PropTypes.node,
    medium: PropTypes.node,
    normal: PropTypes.node,
    large: PropTypes.node,
    other: PropTypes.node,
};

BreakpointsBase.defaultProps = {
    other: null,
};

const Breakpoints = withBreakpoint(BreakpointsBase);

const Small = ({ children }) => <Breakpoints small={children} />;
Small.propTypes = {
    children: PropTypes.node,
};

const Medium = ({ children }) => <Breakpoints medium={children} />;
Medium.propTypes = {
    children: PropTypes.node,
};

const Normal = ({ children }) => <Breakpoints normal={children} />;
Normal.propTypes = {
    children: PropTypes.node,
};

const Large = ({ children }) => <Breakpoints large={children} />;
Large.propTypes = {
    children: PropTypes.node,
};

export default Breakpoints;
export { withBreakpoint, Small, Medium, Normal, Large };



// WEBPACK FOOTER //
// ./src/web/js/contest/components/breakpoints.jsx